export const JOIN_ORGANIZATION_PATH = "/join-organization";

export const joinOrganizationURL = (inviteId: string) => {
    return `${window.location.origin}/join-organization/${inviteId}`;
};
